import type {
  RoutingSmartOverviewResponse,
  RoutingSmartResetResponse,
  RoutingSmartSettingsPatch,
  RoutingSmartSettingsResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/routing-smart';

export async function getRoutingSmartSettings(
  skuId: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<RoutingSmartSettingsResponse> {
  return opsApiRequest<RoutingSmartSettingsResponse>(
    `${BASE}/settings/${encodeURIComponent(skuId)}`,
    { signal },
    fetchImpl,
  );
}

export async function putRoutingSmartSettings(
  skuId: string,
  body: RoutingSmartSettingsPatch,
  fetchImpl: typeof fetch,
): Promise<RoutingSmartSettingsResponse> {
  return opsApiRequest<RoutingSmartSettingsResponse>(
    `${BASE}/settings/${encodeURIComponent(skuId)}`,
    { method: 'PUT', body },
    fetchImpl,
  );
}

export async function getRoutingSmartOverview(
  skuId: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<RoutingSmartOverviewResponse> {
  return opsApiRequest<RoutingSmartOverviewResponse>(
    `${BASE}/overview?sku_id=${encodeURIComponent(skuId)}&fresh=1`,
    { signal },
    fetchImpl,
  );
}

export async function resetRoutingSmart(
  skuId: string,
  fetchImpl: typeof fetch,
): Promise<RoutingSmartResetResponse> {
  return opsApiRequest<RoutingSmartResetResponse>(
    `${BASE}/reset?sku_id=${encodeURIComponent(skuId)}`,
    { method: 'POST' },
    fetchImpl,
  );
}
